import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { DataGrid } from "@material-ui/data-grid"
import { DeleteOutline } from "@material-ui/icons"
// Components
import Topbar from "../../components/Topbar/Topbar"
import Sidebar from "../../components/Sidebar/Sidebar"
// Data
import { deleteEmail, getEmails } from "../../redux/apiCalls"
// Styles
import {
   Container,
   GridWrapper,
   Main,
   Wrapper,
   StyledIcon,
   Action,
   TitleWrapper,
   Title,
} from "./EmailList.styles"

const EmailList = () => {
   const dispatch = useDispatch()
   const emails = useSelector((state) => state.email.emails)

   useEffect(() => {
      getEmails(dispatch)
   }, [dispatch])

   const handleDelete = (id) => {
      deleteEmail(id, dispatch)
   }

   const columns = [
      { field: "orderId", headerName: "ID", width: 120 },
      { field: "createdAt", headerName: "Date", width: 200 },
      {
         field: "emailAddress",
         headerName: "Address",
         width: 300,
      },
      {
         field: "active",
         headerName: "Active",
         width: 120,
      },
      {
         field: "action",
         headerName: "Action",
         width: 150,
         renderCell: (params) => {
            return (
               <Action>
                  <StyledIcon>
                     <DeleteOutline
                        onClick={() => handleDelete(params.row._id)}
                        color="secondary"
                     />
                  </StyledIcon>
               </Action>
            )
         },
      },
   ]

   return (
      <>
         <Topbar />
         <Container>
            <Wrapper>
               <Sidebar />
            </Wrapper>
            <Main>
               <TitleWrapper>
                  <Title>Emails List</Title>
               </TitleWrapper>
               <GridWrapper>
                  <DataGrid
                     rows={emails}
                     u
                     columns={columns}
                     getRowId={(row) => row._id}
                     disableSelectionOnClick
                     pageSize={50}
                     rowsPerPageOptions={[8, 10, 20]}
                     checkboxSelection
                     autoHeight
                  />
               </GridWrapper>
            </Main>
         </Container>
      </>
   )
}

export default EmailList
